var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { NativeContext } from "./ICommonService";
export class CommonService {
    GetServiceName() {
        return CommonService.ServiceName;
    }
    GetNativeContextAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            return yield CommonService.GetNativeContextAsync();
        });
    }
    static GetNativeContextAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            //TODO -- add as soon as we update iOS app to resolve issue 11904166
            //if(window.webkit != null && window.webkit.messageHandlers != null && /iPhone|iPad|iPod/i.test(navigator.userAgent))
            if (window.webkit != null && window.webkit.messageHandlers != null) {
                return NativeContext.IosWebkit;
            }
            else if (navigator.userAgent.endsWith("LavvaAndroidNative")) {
                return NativeContext.AndroidGecko;
            }
            return NativeContext.None;
        });
    }
}
CommonService.ServiceName = "CommonService";
//# sourceMappingURL=CommonService.js.map